<template>
  <div class="container-main-body">
    <!--按钮开始-->
    <div class="list-container">
      <div class="list-btns-container">
        <el-button-group>
          <el-button size="mini" type="warning" icon="el-icon-delete-solid" style="margin-left: 1px;"
            @click="handlerClear">清空</el-button>
          <el-button size="mini" type="primary" icon="el-icon-delete-solid" style="margin-left: 1px;"
            @click="loadData">查询</el-button>
          <el-select size="mini" v-model="queryData.type" filterable placeholder="请选择类型"
            style="width: 200px;margin-left:20px" @change="handlerTypeChange">
            <el-option v-for="item in types" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-select size="mini" v-model="queryData.year" filterable placeholder="请选择年份"
            style="width: 200px;margin-left:20px">
            <el-option v-for="item in years" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-button-group>
      </div>
      <!--按钮结束-->
      <!--列表数据 开始-->
      <div class="echart-container">
        <div v-show="echart1Show" class="myEchart" ref="echartDiv1"></div>
        <div v-show="echart2Show" class="myEchart" ref="echartDiv2"></div>
        <div v-show="echart3Show" class="myEchart" ref="echartDiv3"></div>
        <div v-show="echart4Show" class="myEchart" ref="echartDiv4"></div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts';
export default {
  data: function () {
    return {
      queryData: {
        type: "tz",
        year: '2024'
      },
      types: [{ label: "台纸", value: 'tz' }, { label: "板块", value: 'bk' }, { label: "成品", value: 'cp' }],//类型
      typeName: '台纸',
      years: [{ label: "2024", value: '2024' }],//年份
      echart1Show: true,
      echart2Show: true,
      echart3Show: true,
      echart4Show: true,
      chart1: null,
      chart2: null,
      chart3: null,
      chart4: null,

    };
  },
  created: function () { },
  mounted: function () {
    this.loadData();
  },
  methods: {
    // 加载数据
    loadData: function () {
      let _this = this;
      if (!_this.queryData.type) {
        _this.$message({
          type: 'error',
          message: '查询时类型不能为空！'
        })
        return false
      }
      if (!_this.queryData.year) {
        _this.$message({
          type: 'error',
          message: '查询时年份不能为空！'
        })
        return false
      }
      _this.clearChart()
      _this.echart1Show = true
      _this.echart2Show = true
      _this.echart3Show = true
      _this.echart4Show = true
      _this.post(_this.$apis.getMonthBillByTypeAndYear, this.queryData, function (
        res
      ) {
        let _json = res.data;
        if (_json.status && _json.status === "logout") {
          _this.logout();
        } else {
          console.log("数据：", _json)
          console.log("queryData：", _this.queryData)
          console.log("typeName", _this.typeName)
          switch (_this.queryData.type) {
            case 'tz':
              if (_json.datalistin) {
                var chartDom1 = _this.$refs.echartDiv1;
                _this.chart1 = echarts.init(chartDom1);
                _this.initChart(_this.chart1, _this.typeName + '-入库票据趋势图', '月份', '票数(个)', _json.datalistin, '#0000ff')
              }

              if (_json.datalistout) {
                var chartDom2 = _this.$refs.echartDiv2;
                _this.chart2 = echarts.init(chartDom2);
                _this.initChart(_this.chart2, _this.typeName + '-出库票据趋势图', '月份', '票数(个)', _json.datalistout, '#00ff00')
              }
              _this.echart1Show = true
              _this.echart2Show = true
              _this.echart3Show = false
              _this.echart4Show = false
              break;
            case 'bk':
              if (_json.datalistin) {
                var chartDom1 = _this.$refs.echartDiv1;
                _this.chart1 = echarts.init(chartDom1);
                _this.initChart(_this.chart1, _this.typeName + '-资材入库票据趋势图', '月份', '票数(个)', _json.datalistin, '#0000ff')
              }

              if (_json.datalistout) {
                var chartDom2 = _this.$refs.echartDiv2;
                _this.chart2 = echarts.init(chartDom2);
                _this.initChart(_this.chart2, _this.typeName + '-资材出库票据趋势图', '月份', '票数(个)', _json.datalistout, '#00ff00')
              }

              if (_json.datalistin2) {
                var chartDom3 = _this.$refs.echartDiv3;
                _this.chart3 = echarts.init(chartDom3);
                _this.initChart(_this.chart3, _this.typeName + '-车间入库票据趋势图', '月份', '票数(个)', _json.datalistin2, '#0000ff')
              }

              if (_json.datalistout2) {
                var chartDom4 = _this.$refs.echartDiv4;
                _this.chart4 = echarts.init(chartDom4);
                _this.initChart(_this.chart4, _this.typeName + '-车间出库票据趋势图', '月份', '票数(个)', _json.datalistout2, '#00ff00')
              }
              _this.echart1Show = true
              _this.echart2Show = true
              _this.echart3Show = true
              _this.echart4Show = true
              break;
            case 'cp':
              if (_json.datalistin) {
                var chartDom1 = _this.$refs.echartDiv1;
                _this.chart1 = echarts.init(chartDom1);
                _this.initChart(_this.chart1, _this.typeName + '-入库票据趋势图', '月份', '票数(个)', _json.datalistin, '#0000ff')
              }

              if (_json.datalistout) {
                var chartDom2 = _this.$refs.echartDiv2;
                _this.chart2 = echarts.init(chartDom2);
                _this.initChart(_this.chart2, _this.typeName + '-出库票据趋势图', '月份', '票数(个)', _json.datalistout, '#00ff00')
              }
              _this.echart1Show = true
              _this.echart2Show = true
              _this.echart3Show = false
              _this.echart4Show = false
              break;

            default:
              break;
          }
        }
      });
    },
    clearChart: function () {
      if (this.chart1) {
        this.chart1.dispose() 
      }
      if (this.chart2) {
        this.chart2.dispose()
      }
      if (this.chart3) {
        this.chart3.dispose()
      }
      if (this.chart4) {
        this.chart4.dispose()
      }
    },
    handlerTypeChange: function (value) {
      console.log("handlerTypeChange:",value)
      if (value) {
        this.typeName = this.types.find(option => option.value === value).label;
      }
    },
    handlerClear: function () {
      this.queryData = {
        type: "tz",
        year: '2024'
      }
      this.typeName='台纸'
    },
    initChart(chart, title, xAxisName, yAxisName, datas, lineColor) {
      var names = datas.map(item => item.name);
      var values = datas.map(item => item.value);
      const option = {
        title: {
          text: title,
          left: 'center'
        },
        tooltip: { trigger: 'axis' },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          data: names,
          name: xAxisName,
        },
        yAxis: { name: yAxisName },
        series: [
          {
            name: yAxisName,
            type: 'line',
            data: values,// 设置线条颜色,
            itemStyle : { normal: {label : {show: true}}},
            lineStyle: {
              color: lineColor,
              width: 2
            }
          },
        ],
      };
      chart.setOption(option);
    },
  },
  components: {}
};
</script>
<style scoped>
.echart-container {
  width: 100%;
  position: relative;
  height: 100%;
  overflow-y: auto; /* 开启垂直滚动条 */
}

.myEchart {
  width: 100%;
  height: 300px;
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>